var map = {
	"./Home.vue": [
		8249
	],
	"./Login.vue": [
		2752
	],
	"./activity/ActivityPrize.vue": [
		7928,
		928
	],
	"./agent/AgentArea.vue": [
		8927,
		927
	],
	"./agent/AgentOrder.vue": [
		2634,
		634
	],
	"./agent/AgentRole.vue": [
		8605,
		605
	],
	"./agent/AgentUser.vue": [
		1123,
		123
	],
	"./api/ApiPhonePackage.vue": [
		6673,
		673
	],
	"./api/ApiPointsDiscount.vue": [
		3155,
		155
	],
	"./art/ArticleClassification.vue": [
		5103,
		103
	],
	"./art/ArticleList.vue": [
		1338,
		957
	],
	"./business/BusinessSettleIn.vue": [
		7985,
		985
	],
	"./diy/diy.vue": [
		4200
	],
	"./finance/FinanceOrder.vue": [
		5231,
		231
	],
	"./finance/FinanceOrderExcel.vue": [
		1287,
		287
	],
	"./goods/GoodsClassification.vue": [
		3733,
		733
	],
	"./log/LogAddUserBalance.vue": [
		2523,
		523
	],
	"./log/LogStatisticsOilStation.vue": [
		1351,
		351
	],
	"./log/LogUserBalance.vue": [
		2064,
		64
	],
	"./log/LogUserPoints.vue": [
		180,
		180
	],
	"./mall/MallGoods.vue": [
		4121,
		121
	],
	"./mall/MallGoodsCategory.vue": [
		4099,
		99
	],
	"./mall/MallOrder.vue": [
		6042,
		42
	],
	"./order/OrderList.vue": [
		1700,
		700
	],
	"./order/OrderOil.vue": [
		2422,
		422
	],
	"./order/OrderOilCard.vue": [
		8919,
		919
	],
	"./order/OrderPetroChina.vue": [
		7646,
		254,
		646
	],
	"./order/OrderProportion.vue": [
		6204,
		204
	],
	"./order/OrderReplenish.vue": [
		4654,
		654
	],
	"./order/OrderTelList.vue": [
		7390,
		390
	],
	"./sys/SysArticle.vue": [
		3323,
		254,
		338,
		577
	],
	"./sys/SysCategorical.vue": [
		665,
		254,
		338,
		15
	],
	"./sys/SysPermission.vue": [
		194,
		194
	],
	"./sys/SysRole.vue": [
		764,
		254,
		338,
		548
	],
	"./sys/SysSetting.vue": [
		5939,
		939
	],
	"./sys/SysUser.vue": [
		5902,
		254,
		338,
		822
	],
	"./sys/SyscreateArticle.vue": [
		2870,
		870
	],
	"./test/TestEditor.vue": [
		152,
		152
	],
	"./test/TestOne.vue": [
		6533,
		533
	],
	"./user/UserBankCardInformation.vue": [
		5005,
		5
	],
	"./user/UserBindPetroChina.vue": [
		7434,
		434
	],
	"./user/UserBindSinopec.vue": [
		5464,
		464
	],
	"./user/UserCash.vue": [
		9479,
		479
	],
	"./user/UserCashExamine.vue": [
		5213,
		213
	],
	"./user/UserComplaint.vue": [
		4297,
		297
	],
	"./user/UserDetail.vue": [
		8367,
		367
	],
	"./user/UserInfo.vue": [
		1967,
		967
	],
	"./user/UserList.vue": [
		2023,
		23
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4235;
module.exports = webpackAsyncContext;